import { useState } from "react"
import { Form, Image, Button, Space, Row, Col, Typography, Flex, Divider } from "antd"
import {  MyInput } from '../../components'
import { useDispatch, useSelector } from "react-redux"
import { actionsApi } from "../../shared"
import { Link, useNavigate } from "react-router-dom"

const {Title, Text}= Typography

const ForgotPassword = () => {
    const [form] = Form.useForm()
    const dispatcher = useDispatch();
    const navigate = useNavigate();
    const { loading, otpToken , requestState } = useSelector(state => state?.login);
    
    const forgotpass = () => {
        if (requestState === "request") {
            dispatcher(actionsApi?.forgotPassword(form.getFieldsValue(['email'])));
            
        } 
        if (requestState === "otp") {
            dispatcher(actionsApi?.otpVerify(form.getFieldsValue(['otp'])));
        }
        if (requestState === "reset") {
            const data = form.getFieldsValue(['password', 'confirmationPassword']);
            dispatcher(actionsApi?.resetPassword({data:{token: otpToken, ...data}, navigate}));
        }
    };


    return (
        <Flex className="login-form-cover" justify="center" align="center">
            <div className="login-form">
                <div className="center login-form-left-side">
                    <Flex justify="center" align="center" className="h-100">
                        <Image 
                            src="/assets/images/logo.png" 
                            preview={false} 
                            alt="jsan-logo"
                            width={200}
                        />
                    </Flex>
                    <div className="text-center btm-text">
                        <Text strong className="py-3 text-white">
                            Version 0.0 Beta Release
                        </Text>
                    </div>
                </div>
                <div 
                    style={{alignItems: 'center', display:'flex'}}
                    className="login-form-right-side px-3 py-4"
                >
                    <Space 
                        direction='vertical' 
                        className='justify-center w-100'
                        size={10}
                    >
                        <Image 
                            src="/assets/images/logo.png" 
                            width={'70px'} 
                            preview={false} 
                            alt="jsan"
                        />
                        <Space direction="vertical">
                            <Title level={3} className="my-0">
                                Welcome to JSAN!
                            </Title>
                            <Text level={5} className="text-gray">
                                {requestState === 'request' && 'Forgot Password'}
                                {requestState === 'otp' && 'Enter OTP'}
                                {requestState === 'reset' && 'Reset Password'}
                            </Text>
                        </Space>
                        <Form form={form} layout="vertical" requiredMark={false} className="mt-3">
                            <Row >
                                {requestState === 'request' && (
                                <Col span={24}>
                                    <MyInput
                                    label="Email"
                                    name="email"
                                    required
                                    message="Please enter email"
                                    placeholder=""
                                    />
                                </Col>
                                )}

                                {requestState === 'otp' && (
                                <Col span={24}>
                                    <MyInput
                                        oTp
                                        label="OTP"
                                        name="otp"
                                        type='number'
                                        required
                                        message="Please enter the OTP sent to your email"
                                        placeholder="Enter OTP"
                                        onKeyPress={(e) => {
                                            if (!/[0-9]/.test(e.key)) {
                                              e.preventDefault();
                                            }
                                        }}
                                    />
                                </Col>
                                )}

                                {requestState === 'reset' && (
                                <>
                                    <Col span={24}>
                                        <MyInput
                                            label="New Password"
                                            type="password"
                                            name="password"
                                            required
                                            message={()=>{}}
                                            validator={({ getFieldValue }) => ({
                                                validator: (_, value) => {
                                                    const reg = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*\d).{8,}$/;
                                                    if (!reg.test(value)) {
                                                        return Promise.reject(new Error('Password should contain at least 8 characters, one uppercase letter, one number, one special character'));
                                                    } else {
                                                        return Promise.resolve();
                                                    }
                                                }
                                            })}
                                        />
                                    </Col>
                                    <Col span={24}>
                                        <MyInput
                                            label="Confirm Password"
                                            type="password"
                                            name="confirmationPassword"
                                            dependencies={['password']}
                                            required
                                            message='Please enter confirm password'
                                            rules={[
                                                ({ getFieldValue }) => ({
                                                    validator(_, value) {
                                                        if (!value || getFieldValue('password') === value) {
                                                            return Promise.resolve();
                                                        }
                                                        return Promise.reject(new Error('The password that you entered do not match!'));
                                                    },
                                                }),
                                            ]}
                                            validator={({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value || getFieldValue('password') === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(new Error('The password that you entered do not match!'));
                                                },
                                            })}
                                        />
                                    </Col>
                                </>
                                )}

                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                    <Button
                                        className="fs-14 brand-bg text-white"
                                        htmlType="submit" 
                                        size="large"
                                        block
                                        loading={loading}
                                        onClick={forgotpass}
                                    >
                                        {requestState === 'request' && 'Request for OTP'}
                                        {requestState === 'otp' && 'Verify OTP'}
                                        {requestState === 'reset' && 'Reset Password'}
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                        { requestState === 'request' && (
                        <>
                            <div >
                                <Divider style={{borderColor:'gray'}} className='text-gray mt-4'>
                                    OR
                                </Divider>
                            </div>
                            <Flex gap={10} justify='center' className='mt-3'>
                                <Text className='text-gray'>
                                    <Link to={'/login'} className='px-2'>
                                        <Text className="brand-text" strong>
                                            Sign In
                                        </Text>
                                    </Link>
                                </Text>
                            </Flex>
                        </>
                        )}
                    </Space>
                </div>
            </div>
        </Flex>
    )
}
export {ForgotPassword}